import React, { Component } from 'react'

class TableauDeBord extends Component {
    render(){
        return (<div>Tableau de bord</div>);
    }
}

export default TableauDeBord


// WEBPACK FOOTER //
// ./src/components/content/TableauDeBord.js